<div class="row">
    <div class="col">
        <h4 class="fs-6 d-flex gap-2 mb-3 align-items-center">
            Elige entre {{vehiclePolicies.length}} vehículos en póliza:
        </h4>
        <div class="form-group">
            <input (input)="handleSearch()" [(ngModel)]="searchFilter" class="form-control form-control-sm" placeholder="Buscar vehículo" />
        </div>
        <div class="vehicle-list bg-light p-2 d-flex flex-column gap-2 mt-3 rounded-4">
            @for (policy of filteredVehiclePolicies; track $index) {
            <div (click)="selectVehicle(policy, $index + 1)" class="card shadow-sm rounded-3 p-3 selectable-policy-item" style="cursor: pointer;">
                <div class="d-flex align-items-center gap-1 my-1">
                    <span><strong class="text-colonial">{{policy.vehicleInfo.make}} {{policy.vehicleInfo.model}} - {{policy.vehicleInfo.color}}</strong></span> - <span class="fw-semibold text-colonial">{{policy.vehicleInfo.year }}</span>
                </div>
                <div class="d-flex align-items-center gap-1 small">
                    <span>{{policy.vehicleInfo.registrationNumber }}</span>
                    <span class="small text-muted text-uppercase"> {{policy.vehicleInfo.type }}</span>

                </div>
                <div class="d-flex align-items-center gap-1 small">
                    <span>Referencia:</span>
                    <span>{{$index + 1}}</span>
                </div>
                <div class="d-flex align-items-center gap-1">
                    <span class="fw-semibold">Valor asegurado:</span>
                    <span>${{policy.vehicleInfo.value |  number : '1.0-0'}}</span>
                </div>
            </div>
            } @empty {
            <div class="d-flex justify-content-center p-2">Sin vehículos</div>
            }
        </div>
    </div>
</div>
@if(showBackButton){
    <div class="row">
        <div class="d-flex my-2 align-items-center justify-content-start">
            <button (click)="goBack()" class="btn btn-outline-dark border">
            Regresar
            </button>
        </div>
    </div>
}





